<template>
    <transition name="slide-x-reverse-transition">
        <v-alert
            v-model="value"
            :type="type"
            :title="title"
            :closable="closable"
            location="top right"
            position="fixed"
            class="custom-alert"
        >
            <span v-html="message"></span>
        </v-alert>
    </transition>
</template>

<script setup>

import {useModelWrapper} from "@/js/helpers/modelWrapper";

const props = defineProps({
    modelValue: {},
    type: {
        type: String,
        default: 'success'
    },
    title: {
        type: String,
        default: ''
    },
    message: {
        type: String,
        default: ''
    },
    closable: {
        type: Boolean,
        default: true
    },
});

const emit = defineEmits(["update:modelValue"]);

let value = useModelWrapper(props, emit);

</script>
